import styled from "styled-components";
import { COLORS } from "../../../assets/constants/styles";

export const MessagesBackground = styled.div`
  background-color: ${COLORS.lightViolet};
  border-radius: 0.75rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 300px;
`;

export const MessageWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => (props.$isClient ? "flex-start" : "flex-end")};
  width: 100%;
`;

export const MessageBox = styled.div`
  padding: 1rem;
  border-radius: 0.75rem;
  background-color: ${(props) =>
    props.$isClient ? COLORS.white : COLORS.violet};
  color: ${(props) => (props.$isClient ? COLORS.black : COLORS.white)};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 80%;
  min-width: 26%;
`;

export const MessageAuthor = styled.div`
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
`;

export const MessageText = styled.div`
  font-weight: 400;
  white-space: pre-wrap;
  margin-bottom: 1rem;
  font-size: 0.875rem;
`;

export const MessageTimestamp = styled.div`
  font-size: 0.75rem;
  opacity: 0.7;
  text-align: right;
  position: absolute;
  bottom: 0.5rem;
  right: 1rem;
`;

export const EmptyStateMessage = styled.div`
  text-align: center;
  color: ${COLORS.grey};
  padding: 2rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  gap: 1rem;
`;

export const AddMessageButton = styled.button`
  background-color: ${(props) =>
    props.$isClient ? COLORS.white : COLORS.violet};
  color: ${(props) => (props.$isClient ? COLORS.black : COLORS.white)};
  border: 1px solid
    ${(props) => (props.$isClient ? COLORS.lightViolet : COLORS.violet)};
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background-color: ${(props) => {
      if (props.disabled) return props.$isClient ? COLORS.white : COLORS.violet;
      return props.$isClient ? COLORS.lightestViolet : COLORS.darkViolet;
    }};
    border-color: ${(props) => {
      if (props.disabled)
        return props.$isClient ? COLORS.lightViolet : COLORS.violet;
      return props.$isClient ? COLORS.lightViolet : COLORS.darkViolet;
    }};
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-top: 1rem;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 0.75rem;
  border: 1px solid ${COLORS.lightViolet};
  border-radius: 0.75rem;
  font-family: inherit;
  font-size: 0.875rem;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${COLORS.violet};
  }
`;
